const pages = [
  {
    name: "Accueil",
    page: "home",
    description: "Retour à la page d'accueil",
  },
  {
    name: "Compétences",
    page: "skills",
    description: "Toutes les informations sur les compétences",
  },
  {
    name: "Projets",
    page: "projects",
    description: "Toutes les informations sur les projets",
  },
  {
    name: "Expériences",
    page: "experiences",
    description: "Toutes les informations sur les expériences professionnelles",
  },
  {
    name: "Formations",
    page: "formations",
    description: "Toutes les informations sur les formations",
  },
  {
    name: "Contact",
    page: "contact",
    description: "Toutes les informations sur le contact",
  },
];

export default pages;
